import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { InputText } from "primereact/inputtext";
import * as yup from "yup";
import { format } from "date-fns";
import { EmptyMajorTech } from "./EmptyMajorTech";
import { safeFormatDate } from "../../models/DateFormatMapper";

const schema = yup.object({
    req_CategoryName: yup.string().required("Title is required"),
    req_CategoryDescription: yup.string().required("Description is required"),
});


interface IProps {
    singledata: IMajorTech,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
}

export const AutoAllocateForm = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IMajorTech>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [minummRate, setMinummRate] = useState<number>();
    const [disable, setDisable] = useState<boolean>(false);
    const [rateUpdate, setRateUpdate] = useState<Array<{ req_CategoryID: number, remote_Rate: number | null }>>([]);
    const [onsiteUpdate, setOnsiteRateUpdate] = useState<Array<{ req_CategoryID: number, onsite_Rate: number | null }>>([]);
    const [leadUpdate, setLeadRateUpdate] = useState<Array<{ req_CategoryID: number, lead_Rate: number | null }>>([]);
    const [architectUpdate, setArchitectUpdate] = useState<Array<{ req_CategoryID: number, architect_Rate: number | null }>>([]);


    const [showRate, setShowRate] = useState<boolean>(false);

    const [disablerate, setDisablerate] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IMajorTech>({
        resolver: yupResolver(schema),
        defaultValues: props.singledata,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Requirement_CateGoryLInfo/getSubCategory", "GET", null, `id=${props.singledata.req_CategoryID}`, props.toast);
        if (response) {
            const data: Array<IMajorTech> = await response.json();
            if (data[0].parent_ID == 31) {
                setShowRate(true)
            } else {
                setShowRate(false)

            }
            setTableData({ tableData: data, loading: false });
        }
    }
    const SetMinimumRate = async () => {
        let newReqUpdates: Array<{ req_CategoryID: number, remote_Rate: number | null }> = [];
        for (let i = rateUpdate.length - 1; i >= 0; i--) {
            let avail = false;
            for (let j = 0; j < newReqUpdates.length; j++) {
                if (newReqUpdates[j].req_CategoryID === rateUpdate[i].req_CategoryID) {
                    avail = true;
                    j = newReqUpdates.length;
                }
            }
            if (avail === false) {
                newReqUpdates.push(rateUpdate[i]);
            }
        }
        console.log(rateUpdate);
        setDisable(true);
        setDisablerate(true);
        const response = await Fetch("Requirement_CateGoryLInfo/subctgry", "PUT", newReqUpdates, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Minimum Rate Updated', life: 3000 });
            loadTableData();
            setDisable(false);
             reset(EmptyMajorTech)
            setLoading(false);
            setDisablerate(false);
        } else {
            setDisable(false);
            setDisablerate(false);
        }
    }

    const SetOnsiteRate = async () => {
        let newReqUpdates: Array<{ req_CategoryID: number, onsite_Rate: number | null }> = [];
        for (let i = onsiteUpdate.length - 1; i >= 0; i--) {
            let avail = false;
            for (let j = 0; j < newReqUpdates.length; j++) {
                if (newReqUpdates[j].req_CategoryID === onsiteUpdate[i].req_CategoryID) {
                    avail = true;
                    j = newReqUpdates.length;
                }
            }
            if (avail === false) {
                newReqUpdates.push(onsiteUpdate[i]);
            }
        }
        console.log(rateUpdate);
        setDisable(true);
        setDisablerate(true);
        const response = await Fetch("Requirement_CateGoryLInfo/subctgry", "PUT", newReqUpdates, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Onsite Rate Updated', life: 3000 });
            loadTableData();
            setDisable(false);
             reset(EmptyMajorTech)
            setLoading(false);
            setDisablerate(false);
        } else {
            setDisable(false);
            setDisablerate(false);
        }
    }

    const SetLeadRate = async () => {
        let newReqUpdates: Array<{ req_CategoryID: number, lead_Rate: number | null }> = [];
        for (let i = leadUpdate.length - 1; i >= 0; i--) {
            let avail = false;
            for (let j = 0; j < newReqUpdates.length; j++) {
                if (newReqUpdates[j].req_CategoryID === leadUpdate[i].req_CategoryID) {
                    avail = true;
                    j = newReqUpdates.length;
                }
            }
            if (avail === false) {
                newReqUpdates.push(leadUpdate[i]);
            }
        }
        console.log(rateUpdate);
        setDisable(true);
        setDisablerate(true);
        const response = await Fetch("Requirement_CateGoryLInfo/subctgry", "PUT", newReqUpdates, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Onsite Rate Updated', life: 3000 });
            loadTableData();
            setDisable(false);
             reset(EmptyMajorTech)
            setLoading(false);
            setDisablerate(false);
        } else {
            setDisable(false);
            setDisablerate(false);
        }
    }

    const SetArchitectRate = async () => {
        let newReqUpdates: Array<{ req_CategoryID: number, architect_Rate: number | null }> = [];
        for (let i = architectUpdate.length - 1; i >= 0; i--) {
            let avail = false;
            for (let j = 0; j < newReqUpdates.length; j++) {
                if (newReqUpdates[j].req_CategoryID === architectUpdate[i].req_CategoryID) {
                    avail = true;
                    j = newReqUpdates.length;
                }
            }
            if (avail === false) {
                newReqUpdates.push(architectUpdate[i]);
            }
        }
        console.log(rateUpdate);
        setDisable(true);
        setDisablerate(true);
        const response = await Fetch("Requirement_CateGoryLInfo/subctgry", "PUT", newReqUpdates, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Onsite Rate Updated', life: 3000 });
            loadTableData();
            setDisable(false);
             reset(EmptyMajorTech)
            setLoading(false);
            setDisablerate(false);
        } else {
            setDisable(false);
            setDisablerate(false);
        }
    }

    const saveToDB = async (body: IMajorTech) => {
        setLoading(true);
        body = { req_CategoryName: body.req_CategoryName, req_CategoryStatus: true, parent_ID: props.singledata.req_CategoryID, req_CategoryDescription: body.req_CategoryDescription }
        const response = await Fetch("Requirement_CateGoryLInfo/subCategory", "POST", body, null, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            loadTableData();
        } else setLoading(false);
    }

    const onHide = () => {
        props.hideHistory();
        reset(EmptyMajorTech);
    }
    const onSubmit = (data: IMajorTech) => {
        saveToDB(data);
    }
    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const toggleVal = async (req_CategoryID: number) => {
        const response = await Fetch("Requirement_CateGoryLInfo/toggleSubCategoryStatus", "PUT", null, `req_CategoryID=${req_CategoryID}`, props.toast);
        if (response) {
            let message: string = "Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };

    const SubCategory_Status = (rowData: any) => {
        return (
            <span style={{ color: rowData.req_CategoryStatus ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.req_CategoryID) }}>{rowData.req_CategoryStatus ? "Active" : "InActive"}</span>
        );

    };

    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Sub Category" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVInput column={3} required name="req_CategoryName" label="Title" control={control} error={errors.req_CategoryName?.message} />
                <JVInput column={3} required name="req_CategoryDescription" label="Category Description" control={control} error={errors.req_CategoryDescription?.message} />
                <div className="field col-12 md:col-2">
                    <label htmlFor="">&nbsp;</label>
                    <Button label="SUBMIT" type="submit" loading={loading}></Button>
                </div>
            </form>
            <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>

            <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column field="req_CategoryName" header="Title " style={{ maxWidth: "20rem" }} />
                <Column field="user_Name" header="Created By" style={{ maxWidth: "15rem" }} />
                <Column field="req_CategoryDescription" header="Category Description" style={{ maxWidth: "20rem" }} />
                {showRate && <Column field="remote_Rate" header="Remote Rate" body={(rowData) => <ColumnRateInput toast={props.toast} loadTableData={loadTableData} reset={reset} setLoading={setLoading} rowData={rowData} setRateUpdate={setRateUpdate} rateUpdate={rateUpdate} />} footer={() => <>{(_roles.includes(1) || _roles.includes(26)) &&
                    <Button disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="p-button-outlined w-11rem" label="UPDATE REMOTE RATES" onClick={SetMinimumRate} loading={disablerate}></Button>}</>} />}
                {showRate && <Column field="onsite_Rate" header="Onsite/Hybrid Rate" body={(rowData) => <ColumnOnsiteRateInput toast={props.toast} loadTableData={loadTableData} reset={reset} setLoading={setLoading} rowData={rowData} setOnsiteRateUpdate={setOnsiteRateUpdate} onsiteUpdate={onsiteUpdate} />} footer={() => <>{(_roles.includes(1) || _roles.includes(26)) &&
                    <Button disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="p-button-outlined w-11rem" label="UPDATE ONSITE RATES" onClick={SetOnsiteRate} loading={disablerate}></Button>}</>} />}

                {showRate && <Column field="lead_Rate" header="Lead Rate" body={(rowData) => <ColumnLeadInputProps toast={props.toast} loadTableData={loadTableData} reset={reset} setLoading={setLoading} rowData={rowData} setLeadRateUpdate={setLeadRateUpdate} leadUpdate={leadUpdate} />} footer={() => <>{(_roles.includes(1) || _roles.includes(26)) &&
                    <Button disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="p-button-outlined w-11rem" label="UPDATE LEAD RATES" onClick={SetLeadRate} loading={disablerate}></Button>}</>} />}
                    {showRate && <Column field="architect_Rate" header="Architect Rate" body={(rowData) => <ColumnArchitechtInputProps toast={props.toast} loadTableData={loadTableData} reset={reset} setLoading={setLoading} rowData={rowData} setArchitectRateUpdate={setArchitectUpdate} architectUpdate={architectUpdate} />} footer={() => <>{(_roles.includes(1) || _roles.includes(26)) &&
                    <Button disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="p-button-outlined w-11rem" label="UPDATE ARCHITECT RATES" onClick={SetArchitectRate} loading={disablerate}></Button>}</>} />}
                {/* <Column field="" header="Status" body={(rowData) => <span style={{ color: rowData.req_CategoryStatus ? 'green' : 'red' }}>{rowData.req_CategoryStatus ? "Active" : "Inactive"}</span>} /> */}
                <Column field="" header="Status" body={SubCategory_Status} />

                {/* <Column field="created_at" header="Created On" body={(rowData) => <p>{rowData.created_at ? format(new Date(rowData.created_at), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} /> */}
                  <Column field="created_at" header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_at, 'dd/MM/yyyy', DateFormat)}/>
            </DataTable>
        </Dialog>
    );
}

interface IColumnRateInputProps {
    toast: any,
    loadTableData: () => void,
    reset: (EmptyMajorTech: IMajorTech) => void,
    setLoading: (is: boolean) => void,
    rowData: IMajorTech,
    setRateUpdate: (data: { req_CategoryID: number, remote_Rate: number | null }[]) => void,
    rateUpdate: Array<{ req_CategoryID: number, remote_Rate: number | null }>
}
const ColumnRateInput = (props: IColumnRateInputProps) => {
    const [minummRate, setMinummRate] = useState<number | null>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    return (
        <>
            <InputText disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="w-11rem mr-2" type="number" value={minummRate != null ? minummRate : props.rowData.remote_Rate} onChange={(e: any) => {
                let newRate: Array<{ req_CategoryID: number, remote_Rate: number | null }> | null = props.rateUpdate;
                newRate?.push({ req_CategoryID: props?.rowData?.req_CategoryID || 0, remote_Rate: Number(e.target.value) });
                props.setRateUpdate(newRate);
                setMinummRate(e.target.value);
            }} />

        </>
    );
}


interface IColumnOnsiteInputProps {
    toast: any,
    loadTableData: () => void,
    reset: (EmptyMajorTech: IMajorTech) => void,
    setLoading: (is: boolean) => void,
    rowData: IMajorTech,
    setOnsiteRateUpdate: (data: { req_CategoryID: number, onsite_Rate: number | null }[]) => void,
    onsiteUpdate: Array<{ req_CategoryID: number, onsite_Rate: number | null }>
}
const ColumnOnsiteRateInput = (props: IColumnOnsiteInputProps) => {
    const [onsiteRate, setOnsiteRate] = useState<number | null>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    return (
        <>
            <InputText disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="w-11rem mr-2" type="number" value={onsiteRate != null ? onsiteRate : props.rowData.onsite_Rate} onChange={(e: any) => {
                let newRate: Array<{ req_CategoryID: number, onsite_Rate: number | null }> | null = props.onsiteUpdate;
                newRate?.push({ req_CategoryID: props?.rowData?.req_CategoryID || 0, onsite_Rate: Number(e.target.value) });
                props.setOnsiteRateUpdate(newRate);
                setOnsiteRate(e.target.value);
            }} />

        </>
    );
}

interface IColumnLeadInputProps {
    toast: any,
    loadTableData: () => void,
    reset: (EmptyMajorTech: IMajorTech) => void,
    setLoading: (is: boolean) => void,
    rowData: IMajorTech,
    setLeadRateUpdate: (data: { req_CategoryID: number, lead_Rate: number | null }[]) => void,
    leadUpdate: Array<{ req_CategoryID: number, lead_Rate: number | null }>
}
const ColumnLeadInputProps = (props: IColumnLeadInputProps) => {
    const [leadRate, setLeadRate] = useState<number | null>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    return (
        <>
            <InputText disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="w-11rem mr-2" type="number" value={leadRate != null ? leadRate : props.rowData.lead_Rate} onChange={(e: any) => {
                let newRate: Array<{ req_CategoryID: number, lead_Rate: number | null }> | null = props.leadUpdate;
                newRate?.push({ req_CategoryID: props?.rowData?.req_CategoryID || 0, lead_Rate: Number(e.target.value) });
                props.setLeadRateUpdate(newRate);
                setLeadRate(e.target.value);
            }} />

        </>
    );
}
interface IColumnArchitectInputProps {
    toast: any,
    loadTableData: () => void,
    reset: (EmptyMajorTech: IMajorTech) => void,
    setLoading: (is: boolean) => void,
    rowData: IMajorTech,
    setArchitectRateUpdate: (data: { req_CategoryID: number, architect_Rate: number | null }[]) => void,
    architectUpdate: Array<{ req_CategoryID: number, architect_Rate: number | null }>
}
const ColumnArchitechtInputProps = (props: IColumnArchitectInputProps) => {
    const [architectRate, setArchitectRate] = useState<number | null>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    return (
        <>
            <InputText disabled={(_roles.includes(1) || _roles.includes(26)) ? false : true} className="w-11rem mr-2" type="number" value={architectRate != null ? architectRate : props.rowData.architect_Rate} onChange={(e: any) => {
                let newRate: Array<{ req_CategoryID: number, architect_Rate: number | null }> | null = props.architectUpdate;
                newRate?.push({ req_CategoryID: props?.rowData?.req_CategoryID || 0, architect_Rate: Number(e.target.value) });
                props.setArchitectRateUpdate(newRate);
                setArchitectRate(e.target.value);
            }} />

        </>
    );
}